import Wrapper from './Wrapper';
import Main from './Main';
import MainHeader from './MainHeader';
import MainContent from './MainContent';
import MainContentFixed from './MainContentFixed';
import MainContentFixedHeader from './MainContentFixedHeader';
import Sidebar from './Sidebar';
import SidebarBranding from './SidebarBranding';
import SidebarContent from './SidebarContent';
import Head from './Head';
import Footer from './Footer';
import StickyFooter from './StickyFooter';
import ContentSidenav from './ContentSidenav';
import ContentDismissButton from './ContentDismissButton';
import ContentSideNavTrigger from './ContentSideNavTrigger';
import Title from './Title';

const ProLayout = {
  Wrapper,
  Sidebar,
  SidebarBranding,
  SidebarContent,
  Main,
  MainHeader,
  MainContent,
  MainContentFixedHeader,
  MainContentFixed,
  Head,
  Footer,
  StickyFooter,
  ContentSidenav,
  ContentDismissButton,
  ContentSideNavTrigger,
  Title,
};

export default ProLayout;
